import { render } from "./passwordEmail.vue?vue&type=template&id=07ffc9e4"
import script from "./passwordEmail.vue?vue&type=script&lang=js"
export * from "./passwordEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__